module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tableWrap"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('span', {
    staticClass: "back",
    on: {
      "click": _vm.goBack
    }
  }, [_c('i', [_vm._v(" ")]), _vm._v("返回")]), _vm._v(" "), _c('span', {
    staticClass: "mx"
  }, [_vm._v("BU奖金明细")]), _vm._v(" "), _c('p', {
    staticClass: "select"
  }, [_c('span', [_vm._v("年份：")]), _vm._v(" "), _c('el-select', {
    staticClass: "top-choose",
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.year),
      callback: function($$v) {
        _vm.year = $$v
      },
      expression: "year"
    }
  }, _vm._l((_vm.bonusYearOptions), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "value": item
      }
    })
  })), _vm._v(" "), _c('span', [_vm._v("周期：")]), _vm._v(" "), _c('el-select', {
    staticClass: "top-choose",
    attrs: {
      "clearable": "",
      "placeholder": "请选择",
      "z-noData-text": "请先选择年份"
    },
    model: {
      value: (_vm.cycleId),
      callback: function($$v) {
        _vm.cycleId = $$v
      },
      expression: "cycleId"
    }
  }, _vm._l((_vm.bonusCycleOptions), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.cycle_number_show,
        "value": item.id
      }
    })
  })), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.search()
      }
    }
  }, [_vm._v("查询")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table-main"
  }, [_c('div', {
    staticClass: "main-head"
  }, [_c('div', [_vm._v("日期")]), _vm._v(" "), _c('div', [_vm._v("周期")]), _vm._v(" "), _c('div', [_vm._v("奖金收支(" + _vm._s(_vm.task_curr.currency_name) + ")")]), _vm._v(" "), _c('div', [_vm._v("奖金余额(" + _vm._s(_vm.task_curr.currency_name) + ")")]), _vm._v(" "), _c('div', [_vm._v("详情")])]), _vm._v(" "), _c('z-scrollDiv', {
    staticClass: "main-wrap"
  }, [_vm._l((_vm.dataList), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "main-item"
    }, [_c('div', [_vm._v(_vm._s(item.bill_time))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("cycleStr")(item)))]), _vm._v(" "), _c('div', {
      class: {
        add: item.bill_type == 1, reduce: item.bill_type != 1
      }
    }, [_vm._v(_vm._s(_vm.calcStr(item)))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.balance))]), _vm._v(" "), _c('div', {
      staticClass: "overhide",
      attrs: {
        "title": item.remark
      }
    }, [_vm._v(_vm._s(item.remark))])])
  }), _vm._v(" "), _c('z-noData', {
    attrs: {
      "list": _vm.dataList
    }
  })], 2)], 1), _vm._v(" "), _c('z-pagination', {
    attrs: {
      "data": _vm.data
    },
    on: {
      "getPage": _vm.search
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-a83c308a!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/frontStage/buManage/page-bonusTable.vue
// module id = 780
// module chunks = 1